import React from "react";
// import TextField from "@material-ui/core/TextField";
// import Grid from "@material-ui/core/Grid";
// import Box from "@material-ui/core/Box";
// import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
// import Container from "@material-ui/core/Container";
// import { Link } from "react-router-dom";
import Button from "@material-ui/core/Button";
// import AppProvider from "./../../bootstrap/index";
import { useAuthProvider} from "react-admin";
import {  useField } from "react-final-form";
import { setIn } from "final-form";
// import SignInButton from "../../../Components/button/globleButtons";
// import FilledInput from "@material-ui/core/FilledInput";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
// import AppProvider from "../../bootstrap/index"
// import OutlinedInput from "@material-ui/core/OutlinedInput";
import * as yup from "yup";

const useStyles = makeStyles(theme => ({
  "@global": {
    body: {
      backgroundColor: theme.palette.common.white
    }
  },
  paper: {
    // marginTop: theme.spacing(1),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginBottom: "70%",
    height:"50%"
  },
  avatar: {
    margin: 10,
    width: 300,
    height: 60,
    // margin: theme.spacing(1),
    backgroundColor: "white"
  },
  form: {
    marginLeft:"15%",
    marginRight:"20%",
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1)
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    width:"150%"
  },
  TextField: {
    marginTop: "10%",
    backgroundColor: "#ffffff"
  },
  textField1: {
    flexBasis: 200,
    width: 325,
    marginLeft:"5%"
  },
  coverBackgroundContainer: {
    backgroundColor: "#F7F8F9",
    height: "100vh",
    backgroundSize: "cover",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    paddingLeft: "4%",
    paddingRight: "4%",
    paddingTop: "90px",
    // paddingBottom: "20px"
  }
}));

const ForgotPasswordEmail = props => {
  const classes = useStyles();
  const {
    input: { name, onChange, onFocus, onBlur, value, checked },
    meta
  } = useField("email");
  console.log({ onChange, onFocus, onBlur, value, checked }, meta);
  return (
    <form className={classes.form}>
    <FormControl className={[classes.margin,classes.textField1].join(' ')} error={!!meta.error} >
      <InputLabel htmlFor="component-error" fullwidth>
        Enter  Your Email Address
      </InputLabel>
      <Input
        name={name}
        id="outlined-full-width"
        value={value}
        onChange={onChange}
        aria-describedby="component-error-text"
        variant="outlined"
        fullwidth
      />
      {!!meta.error && (
        <FormHelperText id="component-error-text">{meta.error}</FormHelperText>
      )}
    </FormControl>
    </form>
  );
};

const validationSchema = yup.object({
  email: yup
    .string()
    .email("Invalid Email")
    .required("Email is required.")
});

export const validateForgotPasswordForm = async values => {
  try {
    await validationSchema.validate(values, { abortEarly: false });
  } catch (err) {
    const errors = err.inner.reduce((formError, innerError) => {
      return setIn(formError, innerError.path, innerError.message);
    }, {});
    console.log(errors);
    return errors;
  }
};
// const handleChange=()=>{
//    authProvider.resetPassword({email})
// }
export const ForgotPasswordForm = props => {
  console.log(props);
  const authProvider = useAuthProvider();
  console.log(authProvider);
  // const notify = useNotify();
  const classes = useStyles();
  return (
    <form className={classes.submit} onSubmit={props.handleSubmit}>
      <ForgotPasswordEmail {...props} />
      <div>
        <Button
          variant="contained"
          color="primary"
          style={{
            marginTop: "10%",
            width: "60%",
            marginLeft: "20%",
            marginRight:"20%",
            marginBottom: "5%",
           
          }}
          type="Submit"

        >
          Submit
        </Button>
      </div>
    </form>
  );
};






// import React from 'react';
// import TextField from '@material-ui/core/TextField';
// import Grid from '@material-ui/core/Grid';
// import Box from '@material-ui/core/Box';
// import Typography from '@material-ui/core/Typography';
// import { makeStyles } from '@material-ui/core/styles';
// import Container from '@material-ui/core/Container';
// import { Link} from "react-router-dom";
// import AppBar from "../../header/index"
// import SignInButton from "../../button/globleButtons";
// import AppProvider from "./../../bootstrap/index"



// const useStyles = makeStyles(theme => ({
//   '@global': {
//     body: {
//       backgroundColor: theme.palette.common.white,
//     },
//   },
//   paper: {
//     // marginTop: theme.spacing(1),
//     display: 'flex',
//     flexDirection: 'column',
//     alignItems: 'center',
//   },
//   avatar: {
//     margin: 10,
//     width: 300,
//     height: 60,
//     // margin: theme.spacing(1),
//     backgroundColor: 'white',
//   },
//   form: {
//     width: '100%', // Fix IE 11 issue.
//     marginTop: theme.spacing(1),
//   },
//   submit: {
//     margin: theme.spacing(3, 0, 2),
//   },
//   TextField:{
//     marginTop:"10%",
//     backgroundColor:"#ffffff"
//   },
//   coverBackgroundContainer: {
//     backgroundColor:"#F7F8F9",
//     height: "100vh",
//     backgroundSize: "cover",
//     display: "flex",
//     flexDirection: "column",
//     justifyContent: "center",
//     alignItems: "center",
//     paddingLeft:"4%",
//     paddingRight:"4%",
//     paddingTop:"90px",
//     paddingBottom:"20px"
//   },
// }));


// const ForgotPassword=(props)=> {
  
//   const classes = useStyles();
//   const {
//     handleSubmit,
//   } = props;
  
  
  

//   return (
//     <div className={classes.coverBackgroundContainer}>
//     <AppProvider >

//       <AppBar/>
      
//     <Container component="main" maxWidth="xs" style={{background:"#ffffff",marginTop:"2%",}}>
    
//       <div className={classes.paper} >
//       <Typography component="h6" variant="h6" style={{paddingTop:"4%",}}>
//           Reset Your Password
//         </Typography>
//         <form className={classes.form} onSubmit={handleSubmit}   >
          
//            <TextField
//            className={classes.TextField}
//            autoFocus
//              id="email"
//              name="email"
//             //  margin="normal"
//              required
//              placeholder="Enter Your Email Address"
//             //  label="Email Address"
//              type="email"
//              autoComplete="email"
//              variant="standard"
//              fullWidth
//              />

//         <div style={{marginTop:"10%"}}>
//           <SignInButton buttonname="Continue" />
//           </div>

//           <Grid container >
//             <Grid item xs={12} style={{textAlign:"center",marginTop:"8%"}}>
//               <Link to="/login"  style={{ textDecoration: 'none',color:"#000000",}} >
//                 Remember your password? Login
//               </Link>
//             </Grid>
//           </Grid>
//         </form>
//       </div>
//       <Box mt={8}>
//       </Box>
//     </Container>
//     </AppProvider>

    
//     </div>
//   );
// }


// export default ForgotPassword;